import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'gender'
})
export class GenderPipe implements PipeTransform {
  constructor(private readonly translate: TranslateService) {}

  transform(value: string|null|undefined): string {
    if (!value) return '';


    switch (value.toLowerCase()) {
      case 'male':
        return this.translate.instant('gender.male');
      case 'female':
        return this.translate.instant('gender.female');
      default:
        return value;
    }
  }
}
